import { AnyARecord } from "dns";
import { statusConstants } from "../../containers/EvaluationProjects";
import { Bell, CheckCircle, Target, Folder, FileText, ListTodo, Info } from 'lucide-react';

export const filterTheData = (data:any, filters:any) => {
    let result = data.filter((d:any) => {
        return filters.some((filter:any) => {
            const { filterBy, operator, value, condition } = filter;
            let propertyValue;

            if(filter?.value != '' || (filter?.operator == 'is empty' || filter?.operator == 'is not empty')) {
                switch (filterBy) {
                    case 'Club name':
                        propertyValue = d.name.toLowerCase();
                        break;
                    case 'League':
                        propertyValue = d.leagueName.toLowerCase();
                        break;
                    case 'Star rating':
                        if(d.currentRating != null) {
                            propertyValue = d.currentRating == 1 ? '1 Star'.toLowerCase() : d.currentRating + ' Stars'.toLowerCase();
                        } else {
                            propertyValue = '';
                        }
                        break;
                    case 'Target star rating':
                        if(d.targetRating != null) {
                            propertyValue = d.targetRating == 1 ? '1 Star'.toLowerCase() : d.targetRating + ' Stars'.toLowerCase();
                        } else {
                            propertyValue = '';
                        }
                        break;
                    case 'Project status':
                        if(d.ragb != null) {
                            propertyValue = statusConstants[d.ragb].status.toLowerCase();
                        } else {
                            propertyValue = '';
                        }
                        break;
                    default:
                        return true; // Default to true for unknown filterBy
                }

                // Apply filtering based on filter conditions
                switch (operator) {
                    case 'contains':
                        return propertyValue.includes(value.toLowerCase());
                    case 'equals':
                        return propertyValue === value.toLowerCase();
                    case 'starts with':
                        return propertyValue.startsWith(value.toLowerCase());
                    case 'ends with':
                        return propertyValue.endsWith(value.toLowerCase());
                    case 'is empty':
                        return propertyValue === '';
                    case 'is not empty':
                        return propertyValue !== '';
                    default:
                        return true; // Default to true for unknown operators
                }
            }
        });
    });

    return result;
}

export const siteStatusCalculator = (statuses:any) => {
    
    const SiteReviewStatus = {
        NotEvaluated: 0,
        NotMet: 1,
        Partial: 2,
        Met: 3,
    }
    var result = SiteReviewStatus.NotEvaluated;

    if (statuses && statuses.length)
    {
        if (statuses.every((x:any) => x == SiteReviewStatus.NotMet))
        {
            result = SiteReviewStatus.NotMet;
        }

        if (statuses.some((x:any) => x == SiteReviewStatus.Met))
        {
            result = SiteReviewStatus.Partial;
        }

        if (statuses.every((x:any) => x == SiteReviewStatus.Met))
        {
            result = SiteReviewStatus.Met;
        }

        if (statuses.some((x:any) => x == SiteReviewStatus.NotEvaluated))
        {
            result = SiteReviewStatus.NotEvaluated;
        }
        else if (result == SiteReviewStatus.NotEvaluated && statuses.some((x:any) => x == SiteReviewStatus.Partial))
        {
            result = SiteReviewStatus.Partial;
        }
    }

    return result;
}

export const hasUpdates = (data:any, originalData:any) => {
  return data?.some((item: any, index: number) => {
    const original = originalData[index];
    // Deep comparison of objects
    return JSON.stringify(item) !== JSON.stringify(original);
  });
};

export const hasObjectsUpdates = (data:any, originalData:any) => {
  return JSON.stringify(data) !== JSON.stringify(originalData);
};

export const getAccessCount = (restrictions:any) => {
    if(!restrictions || restrictions.length === 0) return 0;
    return restrictions.filter((r:any) => !r.isRestricted).length;
}

// notification logics

// Color palette for club indicators
const clubColors = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
  '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52B788',
];

export const getClubColor = (clubId:any) => {
  return clubColors[clubId % clubColors.length];
};

export const getIconForType = (type:any) => {
  const iconMap:any = {
    action: CheckCircle,
    goal: Target,
    project: Folder,
    evidence: FileText,
    task: ListTodo,
  };
  return iconMap[type.toLowerCase()] || Info;
};

export const getTimeAgo = (dateString:any) => {
  const now:any = new Date();
  const past:any = new Date(dateString);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
  if (diffHours < 24) return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  if (diffWeeks < 4) return `${diffWeeks} week${diffWeeks > 1 ? 's' : ''} ago`;
  if (diffMonths < 12) return `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
  return `${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
};